<template>
  <div id="hexopayIframe"></div>
</template>
  
<script>
  export default {
    name: "HexopayIframe",
    data:()=>{
      return {
      }
    },

    props: {
      amount: {
        type: Number
      },
      currency: {
        type: String
      },
      url: {
        type: String,
      },
    },
    computed: {
      options() {
        return {
          type: 'inline', // inline / overlay
          id: 'hexopayIframe',
          url: this.url,
          // style: "{.payment-methods,.payment-page,html{background-color:transparent}.payment-methods{border-top:0;color:#fff}#request .input input,#request .input select{background-color:#b2b2b3;color:#fff}}",
          size: { width: 320, height: 790 }, // to fit all customer data without scroll
          style: `
            html { background-color: transparent; }
          `
          // body#iframe .payment-page { background: transparent; }
        }
      }
    },
    methods:{
      payment() {
        console.log('DEBUG BeGateway', this.options)
        const pf = new window.BeGateway(this.options);
        pf.buildForm();
      }
    }
  }
</script>
  
<style scoped lang="scss">
  .gpay-btn {
    width: 100%;
  }
</style>